import { createSlice } from "@reduxjs/toolkit";

export type AccountFeatures = {
    canCreateSite: boolean;
    hideMenus: boolean;
    canDisableSite: boolean;
    canDeleteAccount: boolean;
};

const accountFeaturesSlice = createSlice({
    name: "accountFeatures",
    initialState: {
        canCreateSite: true,
        hideMenus: false,
        canDisableSite: true,
        canDeleteAccount: true,
    } as AccountFeatures,
    reducers: {
        handleAccountFeatures: (state, action) => {
            state.canCreateSite = action.payload.canCreateSite;
            state.hideMenus = action.payload.hideMenus;
            state.canDisableSite = action.payload.canDisableSite;
            state.canDeleteAccount = action.payload.canDeleteAccount;
        },
    },
});

export const { handleAccountFeatures } = accountFeaturesSlice.actions;
export default accountFeaturesSlice.reducer;
